export default "__VITE_ASSET__3fe3b782__"